<template>
  <main>
    <router-view></router-view>
    <b-container class="my-4">
      <b-list-group>
        <b-list-group-item
          to="demography"
        >
          <div class="d-flex w-100 justify-content-between">
            <h3>Growth and decline across Denmark</h3>
            <small class="text-muted">April 2024</small>
          </div>
          <b-row>
            <b-col lg="7">
              Which parts of Denmark are thriving and which are not? This notebook explores how
              the distribution of people and wealth has changed in Denmark in the period 2013 - 2023.
              I find that most Danish municipalities are loosing settlers to a few urban areas and
              that there is an increasing gap in population, wealth, and average age between the thriving
              urban centers and the rest of the country.
            </b-col>
            <b-col cols="12" lg="5">
              <img src="./images/demography.svg" width="100%">
            </b-col>
          </b-row>
        </b-list-group-item>
        <b-list-group-item
          to="loan-expenses"
        >
          <div class="d-flex w-100 justify-content-between">
            <h3>Mortage expenses throughout time</h3>
            <small class="text-muted">June 2022</small>
          </div>
          <b-row>
            <b-col lg="7">
              A recent surge in interest rates combined with a previous surge in house prices
              suggests that right now (June 2022) might be a very expensive time to loan for a
              house.
              This notebook explores how much of an average salary has been required to maintain
              a loan for an average house throughout recent history. I find that mortgage expenses
              relative to salaries are higher now than they have been for 10 years, but the situation
              is still better than at the peak of
              the financial crisis. The data also shows that it was very cheap to loan for a house
              in the early 90's - especially if you brought savings to the table.
            </b-col>
            <b-col cols="12" lg="5">
              <img src="./images/expenses.svg" width="100%">
            </b-col>
          </b-row>
        </b-list-group-item>
        <b-list-group-item
          to="homebidding"
        >
          <div class="d-flex w-100 justify-content-between">
            <h3>Bidding for a home</h3>
            <small class="text-muted">February 2022</small>
          </div>
          <b-row>
            <b-col lg="7">
              This notebook explores how the probability of winning a bidding round for a house
              depends on the size of the bid. I find that a bid 6% above the price yields a 90%
              probability of winning a random home sold above the price and that bidding more
              than this will only slowly increases your probability of winning the bid.
              Interestingly, the price class of the home does not have much impact on how many
              percent to bid above the house, but the type of house does. In general, one must
              bid a larger fraction above the price to ensure a villa.
            </b-col>
            <b-col cols="12" lg="5">
              <img src="./images/homebidding.svg" width="100%">
            </b-col>
          </b-row>
        </b-list-group-item>
        <b-list-group-item
          to="tournaments"
        >
          <div class="d-flex w-100 justify-content-between">
            <h3>Comparing tournament systems</h3>
            <small class="text-muted">February 2021</small>
          </div>
          <b-row>
            <b-col lg="7">
              This notebook explores how likely different tournament systems are to yield the best
              player as the actual winner. Tournaments are simulated based on data from the online
              chess community lichess.org, which allows us to derive the probability of game
              outcomes based on the rating of the individual players. We find that single- and double
              elimination tournaments are equally efficient at finding the best player, when taking
              into account the number of games played. Round-robin, however, is strictly less
              efficient than the other two systems.
            </b-col>
            <b-col cols="12" lg="5">
              <img src="./images/tournaments.svg" width="100%">
            </b-col>
          </b-row>
        </b-list-group-item>
      </b-list-group>
    </b-container>
  </main>
</template>

<script>
export default {
  name: 'notebooksList.vue',
  data() {
    return {
    };
  },
};
</script>
